import React from 'react';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-name">{personalInfo.name}</h3>
            <p className="footer-tagline">
              Backend Engineer & Security Enthusiast
            </p>
            <div className="footer-social">
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <Github size={20} />
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={`mailto:${personalInfo.email}`}
                className="footer-social-link"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Navigation</h4>
              <ul className="footer-link-list">
                <li>
                  <a href="#about" className="footer-link">
                    About
                  </a>
                </li>
                <li>
                  <a href="#experience" className="footer-link">
                    Experience
                  </a>
                </li>
                <li>
                  <a href="#projects" className="footer-link">
                    Projects
                  </a>
                </li>
                <li>
                  <a href="#skills" className="footer-link">
                    Skills
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">More</h4>
              <ul className="footer-link-list">
                <li>
                  <a href="#cybersecurity" className="footer-link">
                    Security
                  </a>
                </li>
                <li>
                  <a href="#certifications" className="footer-link">
                    Certifications
                  </a>
                </li>
                <li>
                  <a href="#contact" className="footer-link">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Get In Touch</h4>
              <ul className="footer-link-list">
                <li>
                  <a href={`mailto:${personalInfo.email}`} className="footer-link">
                    {personalInfo.email}
                  </a>
                </li>
                <li>
                  <a href={`tel:${personalInfo.phone}`} className="footer-link">
                    {personalInfo.phone}
                  </a>
                </li>
                <li>
                  <span className="footer-link-text">{personalInfo.location}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>
          <button onClick={scrollToTop} className="back-to-top">
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;